import { useTheme } from '@mui/material';

export const NewCompensationIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke, tertiary: tertiaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
            <circle cx={20.311} cy={23.227} r={14.417} fill={primaryBackground} opacity={0.5} />
            <path
                fill={primaryStroke}
                d="M33.257 19.566a.658.658 0 0 1 .705.64 15.909 15.909 0 1 1-9.18-14.168c.34.159.47.57.296.904a.706.706 0 0 1-.924.304 14.548 14.548 0 1 0 8.448 13.04.706.706 0 0 1 .655-.72Z"
            />
            <path fill={primaryStroke} d="M32.6 6.672h1.364V20.75H32.6z" />
            <rect
                width={1.364}
                height={6.485}
                x={32.318}
                y={6.563}
                fill={primaryStroke}
                rx={0.682}
                transform="rotate(-45 32.318 6.563)"
            />
            <rect
                width={1.364}
                height={6.484}
                x={33.282}
                y={5.599}
                fill={primaryStroke}
                rx={0.682}
                transform="rotate(45 33.282 5.599)"
            />
            <path
                fill={tertiaryStroke}
                d="M17.913 25.788a14.117 14.117 0 0 1-1.893-.16 7.22 7.22 0 0 1-1.084-.264.613.613 0 0 1-.402-.592c0-.498.527-.844 1.007-.71.168.047.345.091.532.134a9.131 9.131 0 0 0 1.84.23v-3.573a12.525 12.525 0 0 1-1.521-.531 4.192 4.192 0 0 1-1.044-.672 2.538 2.538 0 0 1-.62-.85 3.08 3.08 0 0 1-.194-1.132c0-.578.136-1.073.407-1.486.283-.412.678-.737 1.185-.972.508-.248 1.103-.39 1.787-.425v-.99a.566.566 0 1 1 1.132 0v.972a7.428 7.428 0 0 1 1.698.213c.276.062.539.133.788.213.356.113.527.505.399.857-.136.372-.553.555-.933.442a9.45 9.45 0 0 0-.572-.15 7.659 7.659 0 0 0-1.38-.23v3.555c.779.224 1.427.466 1.946.726.52.247.908.56 1.168.937.27.366.407.843.407 1.433 0 .826-.307 1.498-.92 2.017-.614.507-1.48.82-2.6.937v1.398a.566.566 0 0 1-1.132 0v-1.327Zm1.132-1.45c.696-.071 1.203-.23 1.522-.478.318-.26.477-.59.477-.99 0-.296-.059-.537-.177-.726-.118-.2-.324-.372-.619-.513-.283-.142-.684-.277-1.203-.407v3.113Zm-1.132-8.191c-.424.024-.772.1-1.044.23a1.434 1.434 0 0 0-.619.478c-.13.2-.194.43-.194.69 0 .306.053.571.159.796.118.212.312.395.584.548.27.142.642.271 1.114.39v-3.132Z"
            />
        </svg>
    );
};
